import { render, staticRenderFns } from "./CreateTransferInventoryRequest.vue?vue&type=template&id=05678134&scoped=true"
import script from "./CreateTransferInventoryRequest.vue?vue&type=script&lang=js"
export * from "./CreateTransferInventoryRequest.vue?vue&type=script&lang=js"
import style0 from "./CreateTransferInventoryRequest.vue?vue&type=style&index=0&id=05678134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05678134",
  null
  
)

export default component.exports